import type { CustomerInfo, HotelInfo, AirportInfo, CounterInfo } from '@/entities/application/model/types';
import { formatDateTime } from '@/shared/utils/dateFormat';
import type { InfoItem } from './types';
import { ADMIN_RELATIONSHIP_OPTIONS } from '../model/relationshipOptions';

/**
 * RelationshipWithGuest の Enum値を日本語ラベルに変換する
 */
const getRelationshipLabel = (value: string | undefined): string => {
    if (!value) return '';
    const option = ADMIN_RELATIONSHIP_OPTIONS.find((opt) => opt.value === value);
    return option?.title ?? value;
};

export const buildInfoItemForUserInfo = (customer: CustomerInfo): InfoItem[] => {
    return [
        {
            label: '宿泊予約者氏名',
            value: customer.reservation_holder_name,
        },
        {
            label: '利用者氏名',
            value: customer.user_name,
        },
        {
            label: '宿泊者との関係',
            value: getRelationshipLabel(customer.relationship_with_guest),
        },
        {
            label: 'メールアドレス',
            value: customer.email,
            fullWidth: true,
        },
        {
            label: 'TEL',
            value: customer.phone_number,
        },
        {
            label: '国名',
            value: customer.country_name,
        },
    ];
};

export const buildInfoItemForHotelInfo = (hotel: HotelInfo): InfoItem[] => {
    return [
        {
            label: 'ホテル名',
            value: hotel.japanese_name,
        },
        {
            label: 'チェックイン日',
            value: hotel.check_in_date,
        },
        {
            label: 'ホテル住所',
            value: hotel.japanese_address,
            showIcons: true,
            fullWidth: true,
            latitude: hotel.latitude,
            longitude: hotel.longitude,
        },
        {
            label: 'チェックアウト日',
            value: hotel.check_out_date,
        },
    ];
};

export const buildInfoItemForAirportInfo = (airport: AirportInfo, counter: CounterInfo): InfoItem[] => {
    return [
        {
            label: '到着空港',
            value: `${airport.japanese_name}（${counter.japanese_name}）`,
        },
        {
            label: '空港到着予定日時',
            value: formatDateTime(airport.arrival_plan_time),
        },
        {
            label: 'カウンター到着目安',
            value: formatDateTime(counter.arrival_plan_time),
        },
        {
            label: '預け入れカウンター',
            value: counter.japanese_name,
            showIcons: true,
            fullWidth: true,
            latitude: counter.latitude,
            longitude: counter.longitude,
        },
        {
            label: '航空便名',
            value: airport.flight_number ?? '',
        },
    ];
};
